<template>
	<img
		v-if="!hasError"
		:src="computedSrc"
		@error="hasError = true"
		@load="loading = false"
		:style="{ width: width, height: height }"
		v-bind="$attrs"
	/>
	<AppIcon :name="errorPlaceholder" :width="width" :height="height" v-bind="$attrs" v-else />
</template>

<script setup>
import { ref, computed } from 'vue';
import { loadFile } from '@/v2/utils/index';
import AppIcon from './icon.vue';
import { configs } from '@/v2/system-configs';

const props = defineProps({
	src: {},
	placeholder: {
		type: String,
		default: configs.imagePlaceholder,
	},
	errorPlaceholder: {
		type: String,
		default: 'image-x',
	},
	width: {
		type: String,
	},
	height: {
		type: String,
	},
});

const hasError = ref(false);
const loading = ref(!!props.src);

const computedSrc = computed(() => {
	if (hasError.value) {
		return props.errorPlaceholder;
	}
	if (!props.src) {
		return loadFile(props.placeholder);
	}
	return props.src;
});
</script>

<style lang="scss" scoped></style>
